import * as React from 'react';

interface Props {
  title: string;
}
export default ({ title }: Props) => title && <strong>{title}</strong>;
